import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';

const GAUGE_SIZE = 52;
const GAUGE_THICKNESS = 4;

const CellWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  height: 100%;
  padding: 8px 0;
`;

const Gauge = styled.div`
  display: inline-grid;
  place-items: center;

  > * {
    grid-area: 1 / 1;
  }
`;

const TrackRing = styled(CircularProgress)`
  color: ${FullPalette.GREY_600};
`;

const ValueRing = styled(CircularProgress)`
  color: ${FullPalette.GREEN_700};
`;

const PercentLabel = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${FullPalette.GREY_900};
`;

type Props = {
  matchScore: number | null;
};

const MatchPercentageCell = ({ matchScore }: Props) => {
  if (matchScore === null) {
    return <SecondaryBody>{'--'}</SecondaryBody>;
  }

  const percentage = Math.max(0, Math.min(100, Math.round(matchScore)));

  return (
    <CellWrapper>
      <Gauge>
        <TrackRing
          variant="determinate"
          value={100}
          size={GAUGE_SIZE}
          thickness={GAUGE_THICKNESS}
        />
        <ValueRing
          variant="determinate"
          value={percentage}
          size={GAUGE_SIZE}
          thickness={GAUGE_THICKNESS}
        />
        <PercentLabel>{`${percentage}%`}</PercentLabel>
      </Gauge>
    </CellWrapper>
  );
};

export default MatchPercentageCell;
